// src/app/modules/capitalShare/redux/constants.ts
export const CS_CBS_LOOKUP_REQUEST = 'capitalShare/CBS_LOOKUP_REQUEST'
export const CS_CBS_LOOKUP_SUCCESS = 'capitalShare/CBS_LOOKUP_SUCCESS'
export const CS_CBS_LOOKUP_FAILURE = 'capitalShare/CBS_LOOKUP_FAILURE'
export const CS_CBS_LOOKUP_RESET = 'capitalShare/CBS_LOOKUP_RESET'

export const CS_FETCH_LIST_REQUEST = 'capitalShare/FETCH_LIST_REQUEST'
export const CS_FETCH_LIST_SUCCESS = 'capitalShare/FETCH_LIST_SUCCESS'
export const CS_FETCH_LIST_FAILURE = 'capitalShare/FETCH_LIST_FAILURE'

export const CS_SUBMIT_REQUEST = 'capitalShare/SUBMIT_REQUEST'
export const CS_SUBMIT_SUCCESS = 'capitalShare/SUBMIT_SUCCESS'
export const CS_SUBMIT_FAILURE = 'capitalShare/SUBMIT_FAILURE'

export const CS_FETCH_CASE_REQUEST = 'capitalShare/FETCH_CASE_REQUEST'
export const CS_FETCH_CASE_SUCCESS = 'capitalShare/FETCH_CASE_SUCCESS'
export const CS_FETCH_CASE_FAILURE = 'capitalShare/FETCH_CASE_FAILURE'

export const CS_CHECKER_ACTION_REQUEST = 'capitalShare/CHECKER_ACTION_REQUEST'
export const CS_CHECKER_ACTION_SUCCESS = 'capitalShare/CHECKER_ACTION_SUCCESS'
export const CS_CHECKER_ACTION_FAILURE = 'capitalShare/CHECKER_ACTION_FAILURE'

export const CS_FETCH_FEE_CONFIG_REQUEST = 'capitalShare/FETCH_FEE_CONFIG_REQUEST'
export const CS_FETCH_FEE_CONFIG_SUCCESS = 'capitalShare/FETCH_FEE_CONFIG_SUCCESS'
export const CS_UPDATE_FEE_CONFIG_REQUEST = 'capitalShare/UPDATE_FEE_CONFIG_REQUEST'
export const CS_UPDATE_FEE_CONFIG_SUCCESS = 'capitalShare/UPDATE_FEE_CONFIG_SUCCESS'
